import React from "react";
import {
  Create,
  SimpleForm,
  TopToolbar,
  TextInput,
  required,
  SelectInput,
  ReferenceInput,
  maxLength,
} from "react-admin";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const TrustDocumentCreate = (props) => (
  <Create title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm redirect={props.basePath} variant="outlined">
      <ReferenceInput
        source="documentTypeId"
        reference="trust-document-types"
        fullWidth
      >
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      <TextInput
        source="name"
        multiline
        fullWidth
        validate={[required(), maxLength(100)]}
      />
    </SimpleForm>
  </Create>
);

export default TrustDocumentCreate;
